import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_APP_CONTENT_SNIPPET = gql`
  mutation createContentSnippet(
    $containerId: Int!
    $visible: Boolean!
    $appComponentId: Int!
  ) {
    contentSnippet {
      createContentSnippet(
        baseSnippet: { containerId: $containerId, visible: $visible }
        contentSnippetApp: { appComponentId: $appComponentId }
      ) {
        id
      }
    }
  }
`;

const createAppContentSnippetRequest = ({
  containerId,
  isVisible,
  appComponentId,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={CREATE_APP_CONTENT_SNIPPET}>
    {(createContentSnippet, { loading, error, data }) => {
      const variables = {
        containerId,
        visible: isVisible,
        appComponentId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(
          data.contentSnippet.createContentSnippet.id,
          data.contentSnippet.createContentSnippet.sort
        );
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createContentSnippet}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

createAppContentSnippetRequest.propTypes = {
  appComponentId: PropTypes.number.isRequired,
  containerId: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
};

createAppContentSnippetRequest.defaultProps = {
  isVisible: true,
};

export default createAppContentSnippetRequest;
